import React from "react";
import CardSwiper from "../common/swiperCardSlider/CardSwiper";

const FinalSpiritual = () => {
  return (
    <div className="container container_modified py-xl-4">
      <div className="row align-items-center pt-5 pb-lg-5 pt-sm-0  mb-xl-3">
        <div className="col-12 col-lg-5 order-last order-lg-first">
          <CardSwiper />
        </div>
        <div className="col-12 col-lg-7 mt-3 px-4 mt-md-4 mt-lg-0 order-first order-lg-last ps-lg-5">
          <h2 className="text-orange text-uppercase ps-xl-0 mb-0 fw-semibold font-md text-center text-lg-start">
            The Finest Ashram in Girnar
          </h2>
          <h2 className="common_sub_heading mb-0 text-center text-lg-start">
            Shree Girnar Sadhana Ashram
          </h2>
          <p className="pt-3 mb-0 font-sm fw-medium text-dark-gray opacity_80 text-center mb-5 pe-lg-4 mb-lg-0 pb-lg-0 pb-1 text-lg-start lh_25">
            Welcome to the beginning of the end of your search. Meditation -
            taking the attention to the Source of attention is the simplest and
            most direct way to increase consciousness.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FinalSpiritual;
